<template>
  <div :class="classes">
    <div class="signature" v-for="s in signatures">
      <div class="user-icon">
        <img :src="iconSource" />
      </div>
      <div class="user-name">
        <div class="signature-name" v-if="hasName(s)">
          {{ limitSize(s.firstName) }} {{ limitSize(s.lastName) }}
        </div>
        <div class="signature-name" v-if="!hasName(s)">Someone</div>
        <div class="signature-time">{{ action }} {{ s.timeDifference }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import moment from "moment";

export default {
  name: "last-signatures",

  data: function () {
    return {
      signatures: [],
      updatingTimes: false,
      interval: null,
      subscriptions: [],
    };
  },

  props: {
    campaignId: {
      type: String,
      required: true,
    },
    numberOfSignatures: {
      type: Number,
      default: 5,
    },
    iconSource: {
      type: String,
      default: "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/user-icon.png",
    },
    classes: {
      type: String,
      required: false,
    },
    action: {
      type: String,
      default: "signed",
    },
  },

  async created() {
    // https://firebase.google.com/docs/firestore/query-data/listen#web_2
    this.subscriptions.push(
      await firebase
        .firestore()
        .collection("signatures")
        .where("campaigId", "==", this.campaignId)
        .orderBy("signatureDate", "desc")
        .limit(this.numberOfSignatures)
        .onSnapshot(
          (snapshot) => {
            const datas = [];
            snapshot.forEach((e) => datas.push(e.data()));
            this.signatures = this.updateTimeDifference(datas, true);
          },
          (error) => {
            console.error(error);
          }
        )
    );

    // Update the time signed
    setInterval(() => {
      this.signatures = this.updateTimeDifference(this.signatures);
    }, 60000);
  },

  beforeDestroy() {
    if (this.interval) {
      clearInterval(interval);
    }

    // Unsubscript from all subscriptions
    for (const unsub of this.subscriptions) {
      unsub();
    }
  },

  methods: {
    updateTimeDifference(data, forced) {
      if (this.updatingTimes && !forced) {
        return data;
      }

      this.updatingTimes = true;
      const table = [...data];
      for (const d of table) {
        let timeDifference = moment().diff(moment(d.signatureDate), "minutes");
        let difference = `${timeDifference} minute${
          +timeDifference > 1 ? "s" : ""
        } ago`;
        if (timeDifference === 0) {
          difference = "now";
        } else if (timeDifference >= 60 && timeDifference < 1440) {
          timeDifference = moment().diff(moment(d.signatureDate), "hours");
          difference = `${timeDifference} hour${
            +timeDifference > 1 ? "s" : ""
          } ago`;
        } else if (timeDifference >= 1440) {
          timeDifference = moment().diff(moment(d.signatureDate), "days");
          difference = `${timeDifference} day${
            +timeDifference > 1 ? "s" : ""
          } ago`;
        }
        // Assign the value
        d.timeDifference = difference;
      }
      this.updatingTimes = false;
      return table;
    },
    limitSize(input) {
      if (input && input.length > 32) {
        return `${input.substring(0, 32)}...`;
      } else {
        return input;
      }
    },
    hasName(signature) {
      return signature.firstName && signature.lastName;
    },
  },
};
</script>

<style scoped>
.signature {
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 8px 0;
  font-size: 14px;
  color: var(--wwfGrey22);
}

.user-icon {
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
}

.user-icon img {
  width: 100%;
  height: 100%;
}

.user-name {
  margin-left: 8px;
}

.signature-name {
  font-weight: 600;
}

.signature-time {
  margin-top: 2px;
}
</style>


// WEBPACK FOOTER //
// LastSignatures.vue?44d05e6e